module.exports = __webpack_public_path__ + "media/images/fondo-d6655173117af2e987dda726f55c1ea9.png";